import instance from "services/axiosServices";
import backofficeEnviroment from "utils/backofficeEnviroment";

export interface HistoricoMensagem {
  idOportunidade: string;
  numeroCotacao: string;
  numeroFicha: string;
  idLeadCorretor: string;
  idLead: string;
  mensagem: string;
  idGrupoDestinatario?: number;
  anexo?:
    | {
        base64: string;
        fileName: string;
      }[]
    | null;
}

export const useHistoricoMensagem = async (
  params: HistoricoMensagem
): Promise<any> => {
  const url = `${backofficeEnviroment}/common/backoffice/chat/mensagem/v1`;

  const response = await instance.post(url, params);
  return response?.data;
};
